import { render, staticRenderFns } from "./myAddressJm.vue?vue&type=template&id=2e055214&scoped=true&"
import script from "./myAddressJm.vue?vue&type=script&lang=js&"
export * from "./myAddressJm.vue?vue&type=script&lang=js&"
import style0 from "./myAddressJm.vue?vue&type=style&index=0&id=2e055214&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e055214",
  null
  
)

export default component.exports